const getters = {
  token: (state) => state.app.token,
};
export default getters;
